module.exports = __webpack_public_path__ + "media/images/smart_phone/past_order_history/ic_Calendar-837bec51d4d5c25f09f75669f4f1eddc.png";